
import {getStyle} from './Util';

class GoogleLoadHandler {

	constructor() {
		this.promise = EN_KO.functions.onInitMaps().then( ( [google] ) => google );
	}

	getGoogleApi( libs = [] ) {

		// Load Google Maps and all needed libraries.
		return Promise.resolve().then( async() => {

			// Google is already loaded.
			if ( window.google ) {
				return window.google;
			}

			// Wait for init and return google.
			this.loadScript( libs );
			return this.promise;
		} ).then( async( google )=> {

			if ( libs ) {
				const promises = [].concat( libs ).map( lib => google.maps.importLibrary( lib ) );
				await Promise.all( promises );
			}

			return google;
		} );
	}

	loaded = false;

	loadScript( libs = [] ) {
		// Do not load the script twice.
		if ( this.loaded || window.google ) {
			return;
		}

		const searchParams = new URLSearchParams( {
			'key': this.getApiKey(),
			...( libs ? { 'libraries': [].concat( libs ).join( ',' ) } : {} ),
			'async': 'true',
			'loading': 'async',
			'callback': 'EN_KO.functions.maybeInitMaps',
		} );

		const scriptEl = document.createElement( 'script' );
		scriptEl.async = true;
		scriptEl.src = 'https://maps.googleapis.com/maps/api/js?' + searchParams.toString();

		this.loaded = true;
		document.head.appendChild( scriptEl );
		return this.promise;
	}

	getApiKey() {
		switch ( getStyle() ) {
			case 'giga':
			case 'gigasport':
				return 'AIzaSyDUya-QekyWtXrOTdndrx0Otwh7ofmf4g0';
			case 'koe':
			default:
				return 'AIzaSyB1ct2iQfqDSWU-HnOXBuLsKB_xK4Swrnw';
		}
	}
}

const Handler = new GoogleLoadHandler();

export default Handler;
